webpackJsonp([196944793530482],{

/***/ 1230:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/es/products-services/","langKey":"es"}}

/***/ })

});


// WEBPACK FOOTER //
// path---es-products-services-56a89832242434a6645f.js